<template>
  <i class="icon">
    <slot></slot>
  </i>
</template>
